import styled from 'styled-components';

const Footer = styled.div`
    padding:15px;
    border-radius: 3px;
    grid-column: span 3;
    
    p{
        margin: 0;
        text-align: center;
    }
    b{
        margin-left: 10px;
    }
`;
export { Footer };